import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { MaterialModule } from 'src/app/core/material.module';
import { ReportTemplate } from 'src/app/features/working-area/components/working-area2/types/signal-types';
import { REPORT_READY_STATUSES } from '../../../../enums';
import { AbilityService } from '../../../../services/ability/ability.service';

@Component({
  selector: 'app-test-info',
  templateUrl: './test-info.component.html',
  styleUrls: ['./test-info.component.scss'],
  imports: [MaterialModule, CommonModule, RouterModule],
})
export class TestInfoComponent implements OnInit, OnChanges {
  @Input() currTest: any;
  @Input() patientDetails: any;
  @Input() isBigScreen$: Observable<boolean>;

  previousTestId: string | null = null;
  nextTestId: string | null = null;

  constructor(
    public ability: AbilityService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.updatePrevNext(this.currTest);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updatePrevNext(this.currTest);
  }

  get currentSection() {
    return this.router.url.includes('graphs') ? 'graphs' : 'report';
  }

  private updatePrevNext(test: any) {
    if (!test?.relatedTests?.tests?.length) {
      this.previousTestId = null;
      this.nextTestId = null;
      return;
    }

    const ids =
      this.currentSection === 'report'
        ? test.relatedTests.tests
            .filter((t) => {
              const isReportReady = REPORT_READY_STATUSES.includes(
                t.testStatus,
              );

              const isMsltWithStudy =
                t?.testType === ReportTemplate.MSLT && t?.studyId;

              return isReportReady && !isMsltWithStudy;
            })
            .map((t) => t.id)
        : test.relatedTests.tests.map((t) => t.id);
    console.log({ ids });
    const currentId = test.id;
    const index = ids.indexOf(currentId);

    if (index === -1) {
      this.previousTestId = null;
      this.nextTestId = null;
      return;
    }

    this.previousTestId = index > 0 ? ids[index - 1] : null;
    this.nextTestId = index < ids.length - 1 ? ids[index + 1] : null;
  }
}
